import React from "react";
import styled from "styled-components";

const WhatsappButton = () => {
  return (
    <FloatButton
      href="https://wa.me/265999365380"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" />
    </FloatButton>
  );
};

export default WhatsappButton;

const FloatButton = styled.a`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  background-color: #25d366;
  border-radius: 40%;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  img {
    width: 32px;
    height: 28px;
  }
`;
